"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScrollPosition = useScrollPosition;

var _react = require("react");

/*
    Taken from https://gist.github.com/whoisryosuke/72d9979a44e01e95400760d98ca519e8
*/
const isBrowser = typeof window !== `undefined`;

function getScrollPosition(_ref) {
  let {
    element,
    useWindow
  } = _ref;
  if (!isBrowser) return {
    x: 0,
    y: 0
  };
  const target = element ? element.current : document.body;
  const position = target.getBoundingClientRect();
  return useWindow ? {
    x: window.scrollX,
    y: window.scrollY
  } : {
    x: position.left,
    y: position.top
  };
}

function useScrollPosition(effect, deps, element, useWindow, wait) {
  const position = (0, _react.useRef)(getScrollPosition({
    useWindow
  }));
  let throttleTimeout = null;

  const callBack = () => {
    const currPos = getScrollPosition({
      element,
      useWindow
    });
    effect({
      prevPos: position.current,
      currPos
    });
    position.current = currPos;
    throttleTimeout = null;
  };

  (0, _react.useLayoutEffect)(() => {
    const handleScroll = () => {
      if (wait) {
        if (throttleTimeout === null) {
          throttleTimeout = setTimeout(callBack, wait);
        }
      } else {
        callBack();
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, deps);
}